export const errorMessage = {
  GENERAL: "Can't get data from Storyblok.",
  EMPTY_ID: 'Define story id, url or custom query object.',
  WRONG_CUSTOM: 'Custom query wrong format. Define proper object.',
};

export const STORY_NOT_FOUND = 'Error 404. Story could not be found!';
